import React from "react";
import classname from "classnames";
import { userHasAdminRole, userHasOneOfRoles } from "utils/helpers/functions";
import { Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import { LoginSelector } from "store/auth/login/selectors";
import arrow from "assets/images/svg/arrow-white.svg";

const CustomButton = ({
  text,
  roles,
  hideRoles,
  icon,
  iconImg,
  size,
  color,
  type,
  textColor = "#000",
  disabled,
  className = "",
  isDropdown = false,
  isButtonRound = false,
  ...props
}) => {
  const { user } = useSelector(LoginSelector);

  if (!userHasAdminRole(user)) {
    if (userHasOneOfRoles(hideRoles, user)) {
      return null;
    }
    if (roles && !userHasOneOfRoles(roles, user)) {
      return null;
    }
  }

  return (
    <Tooltip placement="bottom" title={text} color="#444444">
      <>
        <button
          {...props}
          disabled={!!disabled}
          title={text}
          className={classname(
            "button-general",
            className,
            size === "small" && "button-small",
            size === "lite" && "button-lite",
            type === "round" && "button-round",
            type === "success" && "button-success",
            type === "error" && "button-error",
            color === "outlined" && "button-outlined",
            color === "outlined-white" && "button-outlined-white",
            color === "outlined-error" && "button-outlined-error",
            disabled && "button-disabled",
            isDropdown && "button-dropdown",
            isButtonRound && "round-button"
          )}
        >
          {!!iconImg && <img className="image-icon-btn" src={iconImg} alt="button-image" />}
          {!!icon && <span className="button-icon">{icon}</span>}
          {text}
          {isDropdown && (
            <div className="dropdown-img-container">
              <img className="dropdown-img" src={arrow} alt="button-image" />
            </div>
          )}
        </button>
      </>
    </Tooltip>
  );
};
export default CustomButton;
